import { ConfigProvider } from 'antd';
import { PropsWithChildren } from 'react';
import theme from './theme';

const AntdConfigProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return <ConfigProvider theme={theme}>{children}</ConfigProvider>;
};

export default AntdConfigProvider;
